import { CreateJoint, CreateBone } from "@project-rouge/rg-core";
import { Line3, Vector3 } from "three";
import { Side } from "./index242.js";
const _line = new Line3();
function mainThreadToAnatomy(thread, floors) {
  const start = thread.startThread ? projectStartIntoRoot(thread.startThread.thread) : thread.start.clone();
  const end = thread.endThread ? projectStartIntoRoot(thread.endThread.thread) : thread.end.clone();
  if (!thread.startThread) {
    start.addScaledVector(thread.dir, thread.context.facadeWidth);
  }
  if (!thread.endThread) {
    end.addScaledVector(thread.dir, -thread.context.facadeWidth);
  }
  const startJoint = CreateJoint({ pos: start.toArray() });
  const endJoint = CreateJoint({ pos: end.toArray() });
  connectJoints({
    startJoint,
    endJoint,
    floors,
    isSingleLoaded: !!thread.load,
    loadSide: thread.load
  });
  if (thread.startThread)
    addBranchToAnatomy(thread.startThread.thread, floors, startJoint);
  if (thread.endThread)
    addBranchToAnatomy(thread.endThread.thread, floors, endJoint);
  return startJoint;
}
function addBranchToAnatomy(thread, floors, startJoint) {
  const end = thread.endThread ? projectStartIntoRoot(thread.endThread.thread) : thread.end.clone();
  if (!thread.endThread) {
    end.addScaledVector(thread.dir, -thread.context.facadeWidth);
  }
  const endJoint = CreateJoint({ pos: end.toArray() });
  connectJoints({
    startJoint,
    endJoint,
    floors,
    isSingleLoaded: !!thread.load,
    loadSide: thread.load
  });
  if (thread.endThread)
    addBranchToAnatomy(thread.endThread.thread, floors, endJoint);
}
function projectStartIntoRoot(branch) {
  const root = branch.startThread.thread;
  _line.start.copy(root.start);
  _line.end.copy(root.end);
  const pos = _line.closestPointToPoint(branch.start, false, new Vector3());
  return pos;
}
function connectJoints({ startJoint, endJoint, floors, isSingleLoaded, loadSide }) {
  let loads = [true, true];
  if (isSingleLoaded) {
    loads = [loadSide === Side.right, loadSide === Side.left];
  }
  CreateBone({
    joints: [startJoint, endJoint],
    loads,
    closedEnds: [false, false],
    muscles: [],
    floors
  });
}
export {
  mainThreadToAnatomy
};
//# sourceMappingURL=index196.js.map
